import { GetProps, SizableText, Spinner, Stack, XStack, styled } from 'tamagui'
import { ImagePlus } from '@tamagui/lucide-icons'
import { SolitoImage } from 'solito/image'
import { colors } from '../../colors'

const ImageFiledWrapper = styled(Stack, {
  br: '$3',
  bg: '$gray3',
  jc: 'center',
  ai: 'center',
  w: 160,
  h: 160,
  cursor: 'pointer',
  overflow: 'hidden',
  hoverStyle: {
    bg: '$gray4',
    opacity: 0.9,
  },
  focusStyle: {
    bg: '$gray5',
    opacity: 0.9,
  },
  pressStyle: {
    bg: '$gray5',
    opacity: 0.9,
  },
})

type ImageFieldProps = {
  image?: any // TODO: type
  loading?: boolean
  iconProps?: GetProps<typeof ImagePlus>
} & GetProps<typeof ImageFiledWrapper>

export const ImageField = ({ image, iconProps, loading, ...props }: ImageFieldProps) => {
  return (
    <ImageFiledWrapper tag="button" {...props}>
      {image && (
        <SolitoImage
          src={image}
          style={{
            width: '100%',
            height: '100%',
          }}
          width={300}
          height={300}
          contentFit="cover"
          alt="Profile picture"
        />
      )}

      <XStack
        pos="absolute"
        bg="$white"
        bottom="$2"
        left="$2"
        py="$1.5"
        gap="$2"
        ai="center"
        px="$2"
        br="$3"
        bw={2}
        boc="$gray10"
      >
        <ImagePlus size={20} color={colors.gray10} />
        <SizableText size="$1" color="$gray10" fow="500">
          {image ? 'Update' : 'Add'} image
        </SizableText>
      </XStack>

      {loading && (
        <Stack jc="center" zIndex="$5" ai="center" pos="absolute" m="auto" w="100%" h="100%">
          <Spinner />
        </Stack>
      )}
    </ImageFiledWrapper>
  )
}
